module.exports = __webpack_public_path__ + "img/english_app_store.e8f2042f.png";